import instance from "../utils/network";
import {
  RankingDto,
  RankingInfoResponse,
  RankingResponse,
} from "./runner-ranking";

export interface CompanyAllRankingResponse {
  top3: RankingDto[];
  rankings: RankingDto[];
  total: number;
}

export function getCompanyMonthRanking(
  year: number,
  month: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/company-ranking?limit=${limit}&page=${page}&year=${year}&month=${month}`
  );
}
export function getCompanyRanking(
  season: number,
  limit: number,
  page: number
): Promise<RankingResponse> {
  return instance.get(
    `/nest/company-ranking?season=${season}&limit=${limit}&page=${page}`
  );
}

export function getCompanyMonthRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/company-ranking/month-info/${id}`);
}

export function getCompanyRankingInfo(
  id: number
): Promise<RankingInfoResponse> {
  return instance.get(`/nest/company-ranking/info/${id}`);
}

export function getCompanyAllRanking(
  page: number,
  limit: number
): Promise<CompanyAllRankingResponse> {
  return instance.get(`/nest/company-ranking/all?page=${page}&limit=${limit}`);
}
